module.exports = __webpack_public_path__ + "static/media/file-pdf-solid.9d5195e3.svg";